import { MapState } from 'src/app/interfaces/map.interface';
import { CustomMarker } from 'src/app/models/custom-marker.model';
import { SearchResult } from 'src/app/swagger-api/model/searchResult';
import { CardType } from '../../../../views/cards/cards.types';
import { NonAggregatedItemsProcessor } from './non-aggregated-items-processor.strategy';

export class PeopleNonAggregatedItemsProcessor extends NonAggregatedItemsProcessor {
  public constructor(
    private _response: SearchResult[],
    private _state: MapState,
  ) {
    super(_response, _state);
  }

  public filterMarkers(markers: CustomMarker[]): CustomMarker[] {
    return markers.filter((marker: CustomMarker) => this.isMarkerTypeIncompatibleWithState(marker));
  }

  public override getMarkers(): CustomMarker[] {
    const markers: CustomMarker[] = super.getMarkers();
    return this.filterMarkers(markers);
  }

  private isMarkerTypeIncompatibleWithState(marker: CustomMarker): boolean {
    if (this._state.diseases && this._state.diseases.length > 0 && marker.kind === CardType.MED_STAFF) {
      return false;
    } else if (this._state.specialties && this._state.specialties.length > 0 && marker.kind === CardType.PATIENT) {
      return false;
    }
    return true;
  }
}
